exports.DealerNodes = [
    {
        value: "4", label: "Reseller",
        children: [
            { value: "4_1", label: "Add" },
            { value: "4_2", label: "Edit" },
            { value: "4_3", label: "View" },
        ]
    },
    {
        value: "5", label: "Customer",
        children: [
            { value: "5_1", label: "Add" },
            { value: "5_2", label: "Edit" },
            { value: "5_3", label: "View" },
        ]
    },
    {
        value: "8", label: "Subscription",
        children: [
            { value: "8_1", label: "Add" },
            { value: "8_2", label: "Edit" },
            { value: "8_3", label: "View" },
        ]
    },
    { value: "10", label: "Log" }
];

exports.ResellerNodes = [
    {
        value: "5", label: "Customer",
        children: [
            { value: "5_1", label: "Add" },
            { value: "5_2", label: "Edit" },
            { value: "5_3", label: "View" },
        ]
    },
    {
        value: "8", label: "Subscription",
        children: [
            { value: "8_1", label: "Add" },
            { value: "8_2", label: "Edit" },
            { value: "8_3", label: "View" },
        ]
    },
    { value: "10", label: "Log" }
];

// exports.DealerNodes = [
//     {
//         value: "4", label: "Reseller",
//         children: [
//             { value: "4_1", label: "Add" },
//             { value: "4_2", label: "Edit" },
//             { value: "4_3", label: "View" },
//         ]
//     },
//     {
//         value: "6", label: "Customer",
//         children: [
//             { value: "6_1", label: "Add" },
//             { value: "6_2", label: "Edit" },
//             { value: "6_3", label: "View" },
//         ]
//     },
//     {
//         value: "11", label: "Subscription",
//         children: [
//             { value: "11_1", label: "Add" },
//             { value: "11_2", label: "Edit" },
//             { value: "11_3", label: "View" },
//         ]
//     },
//     { value: "15", label: "Log" }
// ];
// exports.ResellerNodes = [
//     {
//         value: "7", label: "Customer",
//         children: [
//             { value: "7_1", label: "Add" },
//             { value: "7_2", label: "Edit" },
//             { value: "7_3", label: "View" },
//         ]
//     },
//     {
//         value: "12", label: "Subscription",
//         children: [
//             { value: "12_1", label: "Add" },
//             { value: "12_2", label: "Edit" },
//             { value: "12_3", label: "View" },
//         ]
//     },
//     { value: "15", label: "Log" }
// ];